module.exports = __webpack_public_path__ + "img/mockup.10559511.png";